import styled from 'foundations-theming/utils';
import { keyframes } from 'styled-components';
const pulse = keyframes(["0%{opacity:0.3;}50%{opacity:0.5;}100%{opacity:0.3;}"]);
const AnimatedBg = styled.div.withConfig({
  displayName: "AnimatedBg",
  componentId: "wbmjiu-0"
})(["background-color:", ";width:100%;height:100%;animation:", " 1.5s ease-in-out infinite;"], ({
  theme
}) => theme.color['fill-tertiary-pressed'], pulse);
export default AnimatedBg;